import React from 'react';
import IntroImage from '../components/IntroImage';
import About from '../components/About';
import Contact from '../components/Contact';
import Footer from '../components/Footer';
const Home = () => {
  return (
    <div>
      <IntroImage />
      <About />
      <Contact />
      <Footer />
    </div>
  );
};

export default Home;
